import { render, staticRenderFns } from "./policeType.vue?vue&type=template&id=711ce4bc&scoped=true"
import script from "./policeType.vue?vue&type=script&lang=js"
export * from "./policeType.vue?vue&type=script&lang=js"
import style0 from "./policeType.vue?vue&type=style&index=0&id=711ce4bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "711ce4bc",
  null
  
)

export default component.exports